import React from "react"
import DefaultedLoanAccountingForm from './Form'

export default function CreateDefaultedLoanAccounting() {
  return <DefaultedLoanAccountingForm isUpdate={ true } />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/DefaultedLoanAccounting/Create.js